import s from './TextBlock.module.scss';
import { t } from '../../i18n';
import PropTypes from 'prop-types';
import Richtext from '../Richtext/Richtext';
import classNames from 'classnames';

const TextBlock = ({ title, content, updatedAt = '', modifier = '' }) => {
    const classes = classNames(s.Root, [s[`Root--${modifier}`]]);
    return (
        <div className={classes}>
            {title && <h2 className={s.Title}>{title}</h2>}
            {!!updatedAt && (
                <div
                    className={
                        s.UpdatedAt
                    }>{`${t('textBlock.updated')} ${updatedAt}`}</div>
            )}
            {content && <Richtext text={content} />}
        </div>
    );
};

TextBlock.propTypes = {
    title: PropTypes.string,
    content: PropTypes.string.isRequired,
    updatedAt: PropTypes.bool,
};

export default TextBlock;
